import React from 'react';
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, useMediaQuery } from '@mui/material';
import {
  StoreOutlined,
  AssignmentOutlined,
  PersonOutline,
  EmailOutlined,
  AssessmentOutlined,
} from '@mui/icons-material';
import { observer } from "mobx-react-lite";
import { withRouter } from 'react-router';
import { useTheme } from '@mui/material/styles';
import { INTERNAL_HEADER_HEIGHT } from '../../../constants/Constants';
import { NAV_TEXT_STYLE, FOOTER_STYLE } from '../../../constants/Styles';
import Colors from '../../../constants/Colors';
import packageJson from '../../../../package.json';
import MenuStore from '../../../stores/internal/MenuStore';

const DRAWER_WIDTH = 200;

const AdminSidePanel = ({ history }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDrawerOpen = MenuStore.isDrawerOpen;

  const tools = [
    { name: 'Accounts', icon: <StoreOutlined sx={{ color: Colors.primaryColor }} />, link: '/admin/sites' },
    { name: 'Projects', icon: <AssignmentOutlined sx={{ color: Colors.primaryColor }} />, link: '/admin/projects' },
    { name: 'Users', icon: <PersonOutline sx={{ color: Colors.primaryColor }} />, link: '/admin/users' },
    { name: 'Emails', icon: <EmailOutlined sx={{ color: Colors.primaryColor }} />, link: '/admin/email-marketing' },
    { name: 'Reports', icon: <AssessmentOutlined sx={{ color: Colors.primaryColor }} />, link: '/admin/reports' }
  ];

  const handleNav = (path) => {
    history.push(path);
    if (isMobile) {
      MenuStore.setIsDrawerOpen(false);
    }
  };

  return (
    <Drawer
      anchor="left"
      variant={isMobile ? 'temporary' : 'permanent'}
      open={isMobile ? isDrawerOpen : true}
      onClose={() => MenuStore.setIsDrawerOpen(false)}
      ModalProps={{ keepMounted: true }}
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        zIndex: isMobile ? 1301 : 'auto',
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          position: 'fixed',
          height: isMobile ? '100vh' : `calc(100vh - ${INTERNAL_HEADER_HEIGHT}px)`,
          top: isMobile ? 0 : INTERNAL_HEADER_HEIGHT,
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <List>
          {tools.map((tool) => (
            <ListItem key={tool.name} button onClick={() => handleNav(tool.link)}>
              <ListItemIcon>{tool.icon}</ListItemIcon>
              <ListItemText primary={<span style={{ ...NAV_TEXT_STYLE }}>{tool.name}</span>} />
            </ListItem>
          ))}
        </List>
        <Box
          sx={{
            ...FOOTER_STYLE,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'column', md: 'row' },
            justifyContent: 'space-between',
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: {
                xs: 'center',
                sm: 'center',
                md: 'center',
              },
            }}
          >
            Developed by <b>BCK</b>
            <br />
            v.{packageJson.version}
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default withRouter(observer(AdminSidePanel));
